import React from 'react';
import normalize from 'components/Dashboard/utilities/normalizeString';

const SingleSelectFilter = (props) => {
  const { filter, selectOption, notIncludeName } = props;
  const { name, options = [], optionSelected = '' } = filter;
  const groupName = normalize(name || 'single-select-filter');

  return (
    <>
      {!notIncludeName && <h3>{name}</h3>}
      <div>
        {options.map((option, index) => {
          const optionName = option?.name ?? '';
          const isDisabled = Boolean(option?.disabled);
          return (
            <div key={`single-select-option-${index}`} className='mb-3'>
              <div className={`radio-button${isDisabled ? ' radio-button--option-disabled' : ''}`}>
                <input
                  id={`${normalize(name)}-${normalize(optionName)}`}
                  name={groupName}
                  onChange={() => {
                    if (!isDisabled) {
                      selectOption({ filter, newValue: optionName });
                    }
                  }}
                  type='radio'
                  checked={optionSelected === optionName}
                  disabled={isDisabled}
                />
                <label
                  htmlFor={`${normalize(name)}-${normalize(optionName)}`}
                  className={isDisabled ? 'text-main-blue-50' : undefined}
                >
                  {optionName}
                </label>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default SingleSelectFilter;
